import React from 'react';
import { Modal, Button, Icon } from 'antd';
import { useTranslation } from 'react-i18next';

const NewScreensWarningModal = ({ visible, onClose }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={<div style={{ display: 'flex', alignItems: 'center' }}>
        <Icon type="desktop" style={{ marginRight: "10px", fontSize: "26px", color: '#faad14' }} />
        <p style={{margin: 0}}>{t('New screens added')}</p>
      </div>}
      visible={visible}
      onCancel={onClose}
      footer={[
        <Button key="ok" type="primary" onClick={onClose}>
          {t('Understood')}
        </Button>
      ]}
    >
      <p style={{ margin: '20px' }}>
        {t('There are new screens, transfer the budget accordingly.')}
      </p>
    </Modal>
  );
};

export default NewScreensWarningModal;
